import { createContext } from 'react';

export const PermissionContext = createContext([]);
export const extractPrivileges = (userPermissionsBasedOnClinic,userRole,clinicId)=>{
    let privileges = [],permissions={},permissionsLoaded=false;
    if (userRole[clinicId] && userPermissionsBasedOnClinic[clinicId]) {
        permissionsLoaded = true;
        userRole[clinicId].forEach(role => {
        permissions = userPermissionsBasedOnClinic[clinicId][role] || {};
        privileges = [...privileges,...(permissions["READ"] || []),...(permissions["WRITE"] || [])];
      });
    }
    return {privileges,permissionsLoaded};
}  